export default "__VITE_ASSET__CAKC38pO__"